import { NgModule } from '@angular/core';
import { ChatUiModule } from '../chat-ui.module';
import { ChatPreferencesModule } from '../chat-preferences/chat-preferences.module';
import { ChatStatusButtonComponent } from './chat-status-button.component';
import { ChatStatusDialogComponent } from './chat-status-dialog.component';
import { ChatTeamStatusComponent } from './chat-team-status.component';

/**
 * Internal Chat presence & status UI (SPEC-2026-07-internal-chat, T-21 ·
 * RF-19/RF-29): the "meu status" control + its picker dialog and the team-status
 * view. Declaration-only module — imported by the EAGER ChatBubbleModule (the
 * popup header carries the status control) and by the lazy ChatModule (full-view
 * header + "Equipe" pane), so it must stay provider-free.
 *
 * ChatPreferencesModule is imported (not just referenced) because the picker
 * opens the preferences dialog through MatDialog.
 */
@NgModule({
  imports: [ChatUiModule, ChatPreferencesModule],
  declarations: [
    ChatStatusButtonComponent,
    ChatStatusDialogComponent,
    ChatTeamStatusComponent,
  ],
  exports: [
    ChatStatusButtonComponent,
    ChatTeamStatusComponent,
  ],
})
export class ChatStatusModule { }
